import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';

import "../carousel/slick/slick.css";
import "../carousel/slick/slick-theme.css"
import Slider from 'react-slick';

import sliderbanner1 from '../../Images/carouselimages/MainBannerDesktop.png'
import sliderbanner2 from '../../Images/carouselimages/business loan (2).png'
import sliderbanner3 from '../../Images/carouselimages/DesktopBanners2.png'
import sliderbanner4 from '../../Images/lenderimages/PoonawallaDesktopBanner.jpg'

const sliderstyle = {
    cursor : 'pointer',
    width: '100%' ,
    maxWidth: '1200px',
    // paddingTop: '5px',
    margin: '0 auto',
    height:'150px'
};

function glidtracker(lender_name) {

    const cookie = new Cookies();

    var glid ='';

    let visitorData = cookie.get('ImeshVisitor');
    if(visitorData)
    {
        visitorData = visitorData.split("|");

        let sd = [];
        visitorData.map((data) => { 
            sd = data.split("=")
            if(sd[0] == "glid"){
                glid = sd[1]
            }
        })
    }

    if(lender_name == 'icici')
    {
        var url = "https://clos.icicibank.com/CAOOD/Apply.jsp?channelId=IndiaMART&utm_source=IndiaMART&utm_medium=BankStatement&utm_campaign=Overdraft&utm_id=InstaOD+Plus";
    }
    if(lender_name == 'poonawalla')
    {
        var url = "https://poonawallafincorp.com/poonawalla-indiamart-business-loan.php?utm_source=IndiaMart_BLSF&utm_medium=website&utm_campaign=IndiaMart_BL &utm_term=business+loan&utm_content=bl&gclid=";
    }

    

    if (glid) {
        if(lender_name == 'icici')
        {
            url += ("&glid=" + glid);
        }
        else if(lender_name == 'poonawalla')
        {
            url += glid;
        }

        window.open(url, '_blank');
    }
    else {
        window.open(url, '_blank');
    }
}

function geturldata(vendor_name) {
    const cookie = new Cookies();

    var glid = '';

    let visitorData = cookie.get('ImeshVisitor');
    if (visitorData) {
        visitorData = visitorData.split("|");

        let sd = [];
        visitorData.map((data) => {
            sd = data.split("=")
            if (sd[0] == "glid") {
                glid = sd[1]
            }
        })
    }

    var host = window.location.hostname;

    if (host == 'loans.indiamart.com') {
        var geturldataURL = "https://loans.indiamart.com/functions.php";
    }
    else {
        var geturldataURL = "https://dev-loans.indiamart.com/functions.php";
    }

    var geturldataPostData = {
        "functionName" : "geturldata",
        "glid": glid,
        "vendor_name": vendor_name
    };

    var formData = new FormData();
    for (var key in geturldataPostData) {
        formData.append(key, geturldataPostData[key]);
    }

    if (glid) {
        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: geturldataURL,
            data: formData,
            timeout: 10000
        }).then(function (response) {

            var data_obj = response['data'];

            window.open(data_obj.red_url, '_blank');

        })
    }
    else {
        if (vendor_name === "CreditEnable Unsecured") {
            window.open('https://www.creditenable.com/in/sme-business-loan/unsecured-business-loans/indiamart-sme-business-loans-v1?', '_blank');
        }
        else if (vendor_name === "CreditEnable Secured") {
            window.open('https://www.creditenable.com/in/sme-business-loan/unsecured-business-loans/indiamart-sme-business-loans-v1?', '_blank');
        }
        else if (vendor_name === "Pirimid") {
            window.open('https://indiamart.ignosis.ai/lsp/ui/api/indiamart/tenant/loan/init', '_blank');
        }
        else if (vendor_name === "CreditMantri") {
            window.open('https://www.creditmantri.com/Indiamart/?utm_content=alliance-lp&alliance_lender=Indiamart&utm_campaign=alliances&utm_source=Indiamart_CoBrandedPage&utm_term=alliance_indiamart', '_blank');
        }
        else if (vendor_name === "LoanTap") {
            window.open('https://loantap.in/journey/start/bl-im?', '_blank');
        }
        else if (vendor_name === "OneInfinity") {
            window.open('https://complementor.oneflo.in/complementor-widget/bil/CONN4128778344?', '_blank');
        }

    }

}

function clicktracking(vendor_name) {

    const cookie = new Cookies();

    var glid = '';

    let visitorData = cookie.get('ImeshVisitor');
    if (visitorData) {
        visitorData = visitorData.split("|");

        let sd = [];
        visitorData.map((data) => {
            sd = data.split("=")
            if (sd[0] == "glid") {
                glid = sd[1]
            }
        })
    }

    var host = window.location.hostname;

    if(host == 'loans.indiamart.com'){
        var getlenderorderURL = "https://loans.indiamart.com/functions.php";
    }
    else{
        var getlenderorderURL = "https://dev-loans.indiamart.com/functions.php";
    }

    var getlenderorderData = {
        "glid" : glid,
        "functionName" : "StoreLenderOrderData",
        "lenderorder" : 'N/A',
        "action" : "Apply Now Click",
        "ApplyNow" : vendor_name,
        "device" : "Desktop" 
    };

    var formData = new FormData();
    for (var key in getlenderorderData) {
        formData.append(key, getlenderorderData[key]);
    }

    if(glid)
    {
        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: getlenderorderURL,
            data: formData,
            timeout:10000
            }).then(function (response) {
            })
    }

}

function gatrack(category, action, label, value = null) {

    const cookie = new Cookies();

    var glid = '';

    let visitorData = cookie.get('ImeshVisitor');
    if (visitorData) {
        visitorData = visitorData.split("|");

        let sd = [];
        visitorData.map((data) => {
            sd = data.split("=")
            if (sd[0] == "glid") {
                glid = sd[1]
            }
        })
    }

    if (value) {
        window.imgtm.push({ 'event': 'IMEvent', 'eventCategory': category, 'eventAction': action, 'eventLabel': label, 'eventValue': value });
    }
    else {
        window.imgtm.push({ 'event': 'IMEvent', 'eventCategory': category, 'eventAction': action, 'eventLabel': label, 'eventValue': glid });
    }
}



class CarouselComponent extends Component 
{

    scrollToElement = (scrolledto) => {
          const element = document.getElementById(scrolledto);
          
          if (element) {
            const yOffset = element.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: yOffset, behavior: 'smooth' });
          }
    };

    oneinfinitybannertrigger = () => {
        geturldata('OneInfinity');
        gatrack('Apply for loan',"OneInfinity Business Loan",'Click');
        clicktracking("OneInfinity Business Loan"); 
    }

    poonawallabannertrigger = () => {
        glidtracker('poonawalla');
    }


    render()
    {
        const settings = {
            autoplay:true,
            autoplaySpeed:5000,
            arrows:false,
            centerMode:false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            adaptiveHeight: true
          };

        return (
            <section style={{ backgroundColor: '#FFF', paddingLeft : '5px', paddingRight : '5px', height:'150px', overflow:'hidden',marginTop:'50px'}}>

                <Slider {...settings}>
                    <div>
                        <img style={sliderstyle} src={sliderbanner1} alt="Main Banner" onClick={() => this.scrollToElement('lenders')}
                        />
                    </div>
                    {/* <div >
                        <img style={sliderstyle} src={sliderbanner4} alt="Poonawalla Banner" onClick={() => this.poonawallabannertrigger()}/>
                    </div> */}

                    {/* <div>
                        <img style={sliderstyle} src={sliderbanner2} alt="Oneinfinity Banner" onClick={() => this.oneinfinitybannertrigger()}
                        />
                    </div> */}
                    <div >
                        <img style={sliderstyle} src={sliderbanner3} alt="All at one place" onClick={() => this.scrollToElement('lenders')}
                        />
                    </div>
                </Slider>
            </section>
        );
    }

}


export default CarouselComponent;
